<mat-form-field class="default-field-width" [formGroup]="form" appearance="fill">
  <mat-label>{{ 'INPUT.MINUTES' | translate }}</mat-label>
  <input type="number" matInput [formControlName]="controlName"
         [min]="1" [max]="20" (input)="onInputChange($event)">
  <mat-error *ngIf="form.get(controlName).hasError('min') || form.get(controlName).hasError('max') ">
    <i>{{ 'ERROR.MINUTES_RANGE' | translate }}</i>
  </mat-error>
  <mat-error *ngIf="form.get(controlName).hasError('required')">
    <i>{{ 'ERROR.REQUIRED' | translate }}</i>
  </mat-error>
</mat-form-field>
